import React, { useContext } from 'react';
import styled from 'styled-components';

import { Text } from '../atom/Text';
import { Button } from '../atom/Button';
import { Flex } from '../atom/Layout';
import Icon from '../atom/Icon';

import { breakpoint, SizeToRem } from '../../../lib/style/ThemeStyle';
import ModalContext from '../../../modules/contexts/Modalcontext';

const Modal = () => {
  const {
    state: {
      isOnModal,
      isButtonAvailable,
      modalContent: { title, content, buttonText },
    },
    actions: { onCloseModal, onConfirmModal },
  } = useContext(ModalContext);

  return (
    isOnModal && (
      <ModalBackground column>
        <ModalContainer column>
          <Text weight="bold" textAlign="center">
            {title}
          </Text>
          <Icon id="closeIcon" iconName="close" onClick={onCloseModal} />
          <ModalContent column>{content}</ModalContent>
          <Button 
            onClick={isButtonAvailable ? onConfirmModal : undefined} 
            color={isButtonAvailable ? "orangePink" : "pinkishGrey"}>
            <Text>{buttonText ? buttonText : '확인'}</Text>
          </Button>
        </ModalContainer>
      </ModalBackground>
    )
  );
};

export default Modal;

export const ModalBackground = styled(Flex)`
  position: fixed;
  z-index: 102;
  width: 100%;
  max-width: ${breakpoint}px;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.32);
`;

const ModalContainer = styled(Flex)`
  position: relative;
  background: ${(props) => props.theme.color.background};
  padding: ${SizeToRem(20)};
  border-radius: 7px;
  box-shadow: 5px 15px 30px 0 rgba(0, 0, 0, 0.16);
  z-index: 102;
  margin: ${SizeToRem(20)};
  width: 90%;

  #closeIcon {
    position: absolute;
    top: 1rem;
    right: 1.25rem;
  }
`;

const ModalContent = styled(Flex)`
  margin: ${SizeToRem(20)} 0 ${SizeToRem(35)};
  max-height: 50vh;
  overflow: auto;
  justify-content: flex-start;
  line-height: 1.43;
  width: 100%;
`;
